import { collection, doc } from 'firebase/firestore';
import { db } from '../firebase';
import { getCareAppUserForPatientQueries, getEffectiveTenantScope } from './patientService';

export async function getEffectiveTenantId() {
  const u = await getCareAppUserForPatientQueries();
  if (!u) return null;
  const scope = getEffectiveTenantScope(u);
  if (scope.mode === 'tenant') return scope.tenantId;
  return u.tenantId || null;
}

export function tenantCollection(tenantId, collectionName) {
  return collection(db, 'tenants', tenantId, collectionName);
}

export function tenantDoc(tenantId, collectionName, docId) {
  return doc(db, 'tenants', tenantId, collectionName, docId);
}

export function tenantPatientCollection(tenantId, patientId, subcollection) {
  return collection(db, 'tenants', tenantId, 'patients', patientId, subcollection);
}

export function tenantPatientDoc(tenantId, patientId, subcollection, docId) {
  return doc(db, 'tenants', tenantId, 'patients', patientId, subcollection, docId);
}
